import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=84c347ec&scoped=true"
import script from "./empresa.vue?vue&type=script&lang=js"
export * from "./empresa.vue?vue&type=script&lang=js"
import style0 from "./empresa.vue?vue&type=style&index=0&id=84c347ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c347ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InformationEmpresaValores: require('/home/luiz/Sistemas/loja/components/Information/EmpresaValores.vue').default,ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
